import React from 'react';
import { Modal } from 'react-bootstrap';
import SupplierCampaignStatusSummary from '../OperationsDashboard/SupplierAnalytics/SupplierCampaignStatusSummary';
import './index.css';

const SupplierCampaignModal = ({ showModal, data, campaignId, campaignName, handleCloseModal }) => {
  const customStyles = {
    content: {
      top: '60%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      width: '70%',
      transform: 'translate(-50%, -50%)',
    },
  };
  return (
    <div>
      {showModal &&
        data &&
        data.length > 0 && (
          <Modal show={showModal} style={customStyles} size='xl'>
            <SupplierCampaignStatusSummary
              data={data}
              campaignId={campaignId}
              campaignName={campaignName}
            />
            <button
              className="btn btn--danger"
              onClick={handleCloseModal}
              style={{
                marginTop: '10px',
                float: 'right',
                backgroundColor: 'rgb(232, 68, 120)',
                fontWeight: '400',
              }}
            >
              Close
            </button>
          </Modal>
        )}
    </div>
  );
};

export default SupplierCampaignModal;
